import { observer } from "mobx-react-lite";
import { cn } from "@heroui/react";
import { contractorDetailStore } from "@/stores/ContractorDetailStore";
import { LEGAL_STEPS } from "../../../constants";

const LegalTabNav: React.FC = observer(() => {
  const { legal } = contractorDetailStore;
  const { currentStep, completedSteps } = legal.drawer;

  return (
    <div className="scd-legal-tabnav">
      {LEGAL_STEPS.map((step) => {
        const isCompleted = completedSteps.has(step.id);
        const isActive = step.id === currentStep;

        return (
          <button
            key={step.id}
            type="button"
            className={cn(
              "scd-legal-tabnav__tab",
              isActive && "scd-legal-tabnav__tab--active",
              isCompleted && "scd-legal-tabnav__tab--completed",
            )}
            onClick={() => legal.goToStep(step.id)}
          >
            {step.label}
          </button>
        );
      })}
    </div>
  );
});

LegalTabNav.displayName = "LegalTabNav";
export default LegalTabNav;
